module.exports = __webpack_public_path__ + "img/PEARLSAsset 209.94d22fd.svg";